import { useDroppable } from "@dnd-kit/core";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { DateTime } from "luxon";
import type { FC } from "react";
import type { NurseFullRole } from "../../../utils/models";
import { InnerBlock, type InnerBlockProps } from "./InnerBlock";

export type DroppableGapData = {
	locationKey: string;
	locationName: string;
	gapStart: DateTime;
	gapEnd: DateTime;
	roles: (NurseFullRole | "all")[];
};

type Props = {
	locationKey: string;
	locationName: string;
	gapStart: DateTime;
	gapEnd: DateTime;
	roles: (NurseFullRole | "all")[];
	gapIdx: string;
} & InnerBlockProps;

export const DroppableGapBlock: FC<Props> = ({ locationKey, locationName, gapStart, gapEnd, roles, gapIdx, ...rest }) => {
	const droppableData: DroppableGapData = {
		locationKey,
		locationName,
		gapStart,
		gapEnd,
		roles,
	};

	const { setNodeRef, isOver } = useDroppable({
		id: `gap-${locationKey}-${gapIdx}`,
		data: droppableData,
	});

	return (
		<Box
			ref={setNodeRef}
			sx={(theme) => ({
				width: "100%",
				...(isOver
					? {
							outline: `2px dashed ${theme.palette.primary.main}`,
							outlineOffset: "-2px",
							backgroundColor: alpha(theme.palette.primary.main, 0.1),
							borderRadius: "4px",
						}
					: {}),
			})}
		>
			<InnerBlock {...rest} />
		</Box>
	);
};
